import React from 'react';
import { Card, CardContent } from './ui/card';
import { 
  Wifi, Smartphone, Sun, FileText, UserCheck, 
  CreditCard, Clock, AlertTriangle
} from 'lucide-react';

const steps = [
  { icon: Wifi, text: 'Ensure stable internet connection (Wi-Fi preferred)', color: 'text-blue-600 bg-blue-50 dark:text-blue-400 dark:bg-blue-900/30' },
  { icon: Smartphone, text: 'Use a charged smartphone, tablet, or laptop with working camera & microphone', color: 'text-blue-600 bg-blue-50 dark:text-blue-400 dark:bg-blue-900/30' },
  { icon: Sun, text: 'Sit in a quiet, well-lit room', color: 'text-blue-600 bg-blue-50 dark:text-blue-400 dark:bg-blue-900/30' },
  { icon: FileText, text: 'Keep all previous medical records, prescriptions, and reports ready (upload while booking if possible)', color: 'text-blue-600 bg-blue-50 dark:text-blue-400 dark:bg-blue-900/30' },
  { icon: UserCheck, text: 'Enter correct name, age, and active mobile number/email', color: 'text-blue-600 bg-blue-50 dark:text-blue-400 dark:bg-blue-900/30' },
  { icon: CreditCard, text: 'Appointment is confirmed only after successful payment', color: 'text-blue-600 bg-blue-50 dark:text-blue-400 dark:bg-blue-900/30' },
  { icon: Clock, text: 'Join the consultation 5 minutes before scheduled time', color: 'text-blue-600 bg-blue-50 dark:text-blue-400 dark:bg-blue-900/30' },
];

const ConsultationPreparation = () => {
  return (
    <Card className="border border-gray-200 dark:border-slate-700 shadow-sm" data-testid="consultation-preparation-card">
      <CardContent className="p-6 sm:p-8 space-y-6">
        {/* Header */}
        <div>
          <h3 className="text-xl font-bold text-gray-900 dark:text-slate-50 mb-1">
            Before Booking Video Consultation
          </h3>
          <p className="text-sm text-gray-500 dark:text-slate-400">Please follow these steps for a smooth experience</p>
        </div>

        {/* Checklist */}
        <div className="space-y-3">
          {steps.map((step, i) => {
            const Icon = step.icon;
            return (
              <div key={i} className="flex items-start gap-3">
                <div className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5 ${step.color}`}>
                  <Icon className="w-4 h-4" />
                </div>
                <p className="text-sm text-gray-700 dark:text-slate-300 leading-relaxed pt-1">{step.text}</p>
              </div>
            );
          })}
        </div>

        {/* Emergency Warning */}
        <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-xl p-4" data-testid="emergency-warning">
          <div className="flex items-start gap-3">
            <AlertTriangle className="w-5 h-5 text-red-600 dark:text-red-400 flex-shrink-0 mt-0.5" />
            <p className="text-sm text-red-800 dark:text-red-300 leading-relaxed">
              <span className="font-semibold">Do not book video consultation for emergencies</span> such as severe breathlessness, 
              chest pain, unconsciousness, heavy bleeding, or oxygen saturation below 90%. 
              Visit the nearest emergency department immediately.
            </p>
          </div>
        </div>

        {/* Terms footer */}
        <p className="text-xs text-gray-400 dark:text-slate-500 text-center pt-1">
          By booking, you agree to teleconsultation terms and privacy policy.
        </p>
      </CardContent>
    </Card>
  );
};

export default ConsultationPreparation;
